import React from "react";
import {
  PRODUCT_STATUS_OPTIONS,
  productStatusLabel,
  resolveProductActiveStatus,
} from "../../utils/productStatus";

const KNOWN_STATUSES = new Set(
  PRODUCT_STATUS_OPTIONS.map((option) => option.id),
);

/**
 * Shared product status control used on catalog cards and admin product tables.
 * When onStatusChange is set, the control is the three-status list.
 */
const ProductStatusBadge = ({
  status,
  product,
  onStatusChange,
  pending = false,
  className = "",
}) => {
  const badgeStatus = status || resolveProductActiveStatus(product) || null;
  if (!KNOWN_STATUSES.has(badgeStatus)) return null;

  const canChange = typeof onStatusChange === "function" && !pending;
  const classNames = [
    "product-status-badge",
    badgeStatus,
    onStatusChange ? "product-status-badge--toggle" : "",
    pending ? "product-status-badge--pending" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const label = productStatusLabel(badgeStatus);

  if (!onStatusChange) {
    return (
      <span className={classNames} aria-label={label}>
        {label}
      </span>
    );
  }

  return (
    <span className={classNames}>
      <span className="product-status-badge__label" aria-hidden="true">
        {label}
      </span>
      {pending ? (
        <span className="product-status-badge__spinner" aria-hidden="true" />
      ) : null}
      {/* Transparent overlay: a visible select would size to its longest option. */}
      <select
        className="product-status-badge__select"
        value={badgeStatus}
        title={pending ? "מעדכן סטטוס…" : "בחר סטטוס"}
        aria-label={pending ? "מעדכן סטטוס…" : label}
        aria-busy={pending || undefined}
        disabled={!canChange}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          if (!canChange) return;
          e.stopPropagation();
          onStatusChange(e.target.value);
        }}
      >
        {PRODUCT_STATUS_OPTIONS.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    </span>
  );
};

export default ProductStatusBadge;
